import get from 'lodash/get';
import { Modal } from 'antd';
import { getRequestData } from '@/utils';

import {
  qryEnumberList4Staff,
  agentEvoucherQry,
  queryAccountBsnl,
  queryHisBillBsnl,
  recharge4User,
  queryRechargeHisBsnl,
  queryrequestId,
  checkStaffOtpFlag,
} from '@/pages/BillPayment/services/billpayment';

export default {
  namespace: 'billpayment',
  state: {
    enumber: '', // 当前员工的etopupnumber
    displayBalValue: '', // 代理商ENumber余额 已处理过精度的显示余额
    balValue: '', // 代理商ENumber余额 未处理过精度的余额
    totalOutstanding: '', // 当前订户号码欠费
    accountNumber: '', // 账户编码
    billList: [], // 历史账单信息
    serviceNumber: '', // 当前订户号码
    payAmount: '', // 充值金额
    orderNumber: '', // 订单号
    rechargeList: [], // 充值历史记录
    accountFlag: false, // 账号不属于Franchisee
    requestId: '', // 缴账生成ETC的requestId
    otpFlag: '', // 充值是否需要发送验证码
  },
  effects: {
    *qryEnumberList4Staff({ payload }, { call, put }) {
      const { staffId } = payload;
      const response = yield call(qryEnumberList4Staff, staffId);
      const enumberList = getRequestData(response);
      yield put({
        type: 'save',
        payload: {
          enumber: get(enumberList, ['0', 'enumber']),
        },
      });
      return get(enumberList, ['0', 'enumber']);
    },
    *agentEvoucherQry({ payload }, { call, put }) {
      const response = yield call(agentEvoucherQry, payload);
      const { evoucherObjList } = getRequestData(response);
      yield put({
        type: 'save',
        payload: {
          displayBalValue: get(evoucherObjList, ['0', 'displayBalValue']),
          balValue: get(evoucherObjList, ['0', 'balValue']),
        },
      });
    },
    *queryAccountBsnl({ payload }, { call, put }) {
      const response = yield call(queryAccountBsnl, payload);
      const data = getRequestData(response);
      const { returnMsg = '', returnCode = '' } = data;
      if (`${returnCode}` !== '0') {
        Modal.warning({
          content: returnMsg,
        });
        yield put({
          type: 'save',
          payload: {
            accountFlag: true,
          },
        });
        return;
      }
      yield put({
        type: 'save',
        payload: {
          totalOutstanding: data.totalDue,
          accountNumber: data.accountCode,
          custName: data.custName,
          accountFlag: false,
        },
      });
    },
    *queryHisBillBsnl({ payload }, { call, put }) {
      const response = yield call(queryHisBillBsnl, payload);
      const { billDtoList } = getRequestData(response);
      yield put({
        type: 'save',
        payload: {
          billList: billDtoList || [],
        },
      });
    },
    *recharge4User({ payload }, { call, put }) {
      const response = yield call(recharge4User, payload);
      const { data } = response;
      yield put({
        type: 'save',
        payload: {
          orderNumber: data.transactionId,
        },
      });
      return data;
    },
    *queryRechargeHisBsnl({ payload }, { call, put }) {
      const response = yield call(queryRechargeHisBsnl, payload);
      const { rechargeDtoList } = getRequestData(response);
      yield put({
        type: 'save',
        payload: {
          rechargeList: rechargeDtoList,
        },
      });
    },
    *queryrequestId({ payload }, { call, put }) {
      const response = yield call(queryrequestId, payload);
      const { requestId } = getRequestData(response);
      yield put({
        type: 'save',
        payload: {
          requestId,
        },
      });
    },
    *checkStaffOtpFlag({ payload }, { call, put }) {
      const response = yield call(checkStaffOtpFlag, payload);
      const { otpFlag } = getRequestData(response);
      yield put({
        type: 'save',
        payload: {
          otpFlag,
        },
      });
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
